export const GET_DISCOUNT_CODES = 'GET_DISCOUNT_CODES'
export const GET_DISCOUNT_CODE = 'GET_DISCOUNT_CODE'
